// v-gixtip="text" — a lightweight, good-looking tooltip.
//
// Rendered on <body> with position:fixed so it escapes any overflow:hidden
// ancestor (the slider's performance panel clips, which is why the native
// `title` had to be used before). Shows instantly on hover, focus, and click,
// fixing the native tooltip's delay and click quirk.

let tipEl = null

function ensureTip() {
    if (!tipEl) {
        tipEl = document.createElement('div')
        tipEl.className = 'gix-tooltip'
        document.body.appendChild(tipEl)
    }
    return tipEl
}

// Color accent based on the trigger's state class, if present.
function toneFor(el) {
    if (el.classList.contains('compat-issue-incompatible') || el.classList.contains('indicate-sad')) { return 'incompatible' }
    if (el.classList.contains('compat-issue-warning') || el.classList.contains('warning-switch')) { return 'warning' }
    if (el.classList.contains('compat-issue-compatible') || el.classList.contains('indicate-ok')) { return 'compatible' }
    return ''
}

function show(el) {
    const text = el.__gixtip
    if (!text) { return }
    if (el.__gixtipTruncatedOnly && !isTruncated(el)) { return }
    const tip = ensureTip()
    tip.textContent = text
    tip.className = 'gix-tooltip'
    const tone = toneFor(el)
    if (tone) { tip.classList.add('gix-tooltip--' + tone) }
    tip.classList.add('gix-tooltip--visible')

    const margin = 8
    const r = el.getBoundingClientRect()
    const t = tip.getBoundingClientRect()
    let left = r.left + r.width / 2 - t.width / 2
    left = Math.max(margin, Math.min(left, window.innerWidth - t.width - margin))
    let top = r.top - t.height - 9
    if (top < margin) {
        top = r.bottom + 9
        tip.classList.add('gix-tooltip--below')
    }
    tip.style.left = Math.round(left) + 'px'
    tip.style.top = Math.round(top) + 'px'
}

function hide() {
    if (tipEl) { tipEl.classList.remove('gix-tooltip--visible') }
}

function isTruncated(el) {
    const target = el.querySelector('[data-gixtip-overflow]') || el
    return target.scrollWidth > target.clientWidth + 1
}

export default {
    bind(el, binding) {
        el.__gixtip = binding.value
        el.__gixtipTruncatedOnly = !!(binding.modifiers && binding.modifiers.truncated)
        el.__gixtipDelay = el.__gixtipTruncatedOnly ? 400 : 0
        el.__gixShow = function () {
            if(el.__gixtipTimer){ clearTimeout(el.__gixtipTimer) }
            if(!el.__gixtipDelay){ show(el); return }
            el.__gixtipTimer = setTimeout(function () {
                el.__gixtipTimer = null
                show(el)
            }, el.__gixtipDelay)
        }
        el.__gixHide = function () {
            if(el.__gixtipTimer){
                clearTimeout(el.__gixtipTimer)
                el.__gixtipTimer = null
            }
            hide()
        }
        el.addEventListener('mouseenter', el.__gixShow)
        el.addEventListener('mouseleave', el.__gixHide)
        el.addEventListener('focus', el.__gixShow)
        el.addEventListener('blur', el.__gixHide)
        el.addEventListener('click', el.__gixShow)
    },
    update(el, binding) {
        el.__gixtip = binding.value
        el.__gixtipTruncatedOnly = !!(binding.modifiers && binding.modifiers.truncated)
        el.__gixtipDelay = el.__gixtipTruncatedOnly ? 400 : 0
    },
    unbind(el) {
        if(el.__gixtipTimer){ clearTimeout(el.__gixtipTimer) }
        el.removeEventListener('mouseenter', el.__gixShow)
        el.removeEventListener('mouseleave', el.__gixHide)
        el.removeEventListener('focus', el.__gixShow)
        el.removeEventListener('blur', el.__gixHide)
        el.removeEventListener('click', el.__gixShow)
        hide()
    }
}
